<template>
  <div id="ReceiptRequest">
    <div class="receipt-request-container">
      <div class="title">오픈페이 서비스 신청하기</div>
      <div class="guide">담당자 확인 후 연락 드리겠습니다.</div>

      <div class="request-container">
        <div class="requirements">01. ID</div>
        <div class="input-box">
          <input type="email" inputmode="email" name="" class="input-item input-item-default" v-model="request.id" placeholder="사용하실 ID를 입력해 주세요." @keyup="onSubmit">
          <button class="btn-empty" :class="{ on: request.id.length > 0 }" @click="request.id = ''; onSubmit();"></button>
        </div>
      </div>

      <div class="request-container">
        <div class="requirements">02. 상호명</div>
        <div class="input-box">
          <input type="email" inputmode="email" name="" class="input-item input-item-default" v-model="request.pw" placeholder="상호명을 입력해 주세요." @keyup="onSubmit">
          <button class="btn-empty" :class="{ on: request.pw.length > 0 }" @click="request.pw = ''; onSubmit();"></button>
        </div>
      </div>

      <div class="request-container">
        <div class="requirements">03. 신청자 이름 </div>
        <div class="input-box">
          <input type="email" inputmode="email" name="" class="input-item input-item-default" v-model="request.name" placeholder="신청자 이름을 입력해 주세요." @keyup="onSubmit">
          <button class="btn-empty" :class="{ on: request.name.length > 0 }" @click="request.name = ''; onSubmit();"></button>
        </div>
      </div>

      <div class="request-container">
        <div class="requirements">04. 연락처 </div>
        <div class="input-row-box">
          <span class="row-title">H.P</span>
          <input type="email" inputmode="email" name="" class="row-input" v-model="request.hp" placeholder="" @keyup="onSubmit">
          <button class="btn-empty" :class="{ on: request.hp.length > 0 }" @click="request.hp = ''; onSubmit();"></button>
        </div>
        <div class="input-row-box">
          <span class="row-title">매장</span>
          <input type="email" inputmode="email" name="" class="row-input" v-model="request.storePhoneNumber" placeholder="" @keyup="onSubmit">
          <button class="btn-empty" :class="{ on: request.storePhoneNumber.length > 0 }" @click="request.storePhoneNumber = ''; onSubmit();"></button>
        </div>
      </div>

      <div class="request-container">
        <div class="requirements">05. E-Mail (세금계산서 수취용) : </div>
        <div class="input-box">
          <input type="text" name="" class="input-item input-item-default" v-model="request.email" :placeholder="``" @keyup="onSubmitEmail" ref="email">
          <button class="btn-empty" :class="{ on: request.email.length > 0 }" @click="request.email = ''; onSubmit();"></button>
        </div>
        <div class="email-error-msg" :class="{ show: emailErrorMSG }">{{ $t('email-error') }}</div>
      </div>

      <div class="request-container">
        <div class="requirements">06. 배달대행회사 계좌정보 </div>
        <div class="input-row-box">
          <span class="row-title">은행명</span>
          <input type="email" inputmode="email" name="" class="row-input" v-model="request.deliveryName" placeholder="" @keyup="onSubmit">
          <button class="btn-empty" :class="{ on: request.deliveryName.length > 0 }" @click="request.deliveryName = ''; onSubmit();"></button>
        </div>
        <div class="input-row-box">
          <span class="row-title">가상계좌번호</span>
          <input type="email" inputmode="email" name="" class="row-input" v-model="request.deliveryAccountNumber" placeholder="" @keyup="onSubmit">
          <button class="btn-empty" :class="{ on: request.deliveryAccountNumber.length > 0 }" @click="request.deliveryAccountNumber = ''; onSubmit();"></button>
        </div>
        <div class="input-row-box">
          <span class="row-title">예금주</span>
          <input type="email" inputmode="email" name="" class="row-input" v-model="request.deliveryPhoneNumber" placeholder="" @keyup="onSubmit">
          <button class="btn-empty" :class="{ on: request.deliveryPhoneNumber.length > 0 }" @click="request.deliveryPhoneNumber = ''; onSubmit();"></button>
        </div>
      </div>

      <div class="request-container">
        <div class="requirements">07. 사업자 등록증</div>
        <div class="input-box">
          <input type="file" name="" id="BusinessRegistration" class="input-item input-item-default input-file" :placeholder="`${ $t('request-msg-placeholder') }`" @change="businessFile">
          <label class="file-select-box" for="BusinessRegistration">
            <div class="file-select-inputbox">{{ file.business }}</div>
            <span class="file-select-button">파일업로드</span>
          </label>
          <button class="btn-empty"></button>
        </div>
      </div>

      <!-- <div class="request-container">
        <div class="requirements">08.주민등록증 (선택사항) </div>
        <div class="input-box">
          <input type="file" name="" id="RegistrationCard" class="input-item input-item-default input-file" :placeholder="`${ $t('request-msg-placeholder') }`" @change="residentFile">
          <label class="file-select-box" for="RegistrationCard">
            <div class="file-select-inputbox">{{ file.resident }}</div>
            <span class="file-select-button">파일업로드</span>
          </label>
          <button class="btn-empty"></button>
        </div>
      </div> -->

      <div class="request-container">
        <div class="requirements">08. 배달대행회사 이름 : </div>
        <div class="input-box">
          <input type="text" name="" class="input-item input-item-default" v-model="request.deliveryAgency.name" :placeholder="``" @keyup="onSubmit" ref="name">
          <button class="btn-empty" :class="{ on: request.deliveryAgency.name.length > 0 }" @click="request.deliveryAgency.name = ''; onSubmit();"></button>
        </div>
      </div>

      <div class="request-container">
        <div class="requirements">09. 배달대행회사 사업자번호 : </div>
        <div class="input-box">
          <input type="text" name="" class="input-item input-item-default" v-model="request.deliveryAgency.businessNum" :placeholder="``" @keyup="onSubmit" ref="businessNum">
          <button class="btn-empty" :class="{ on: request.deliveryAgency.businessNum.length > 0 }" @click="request.deliveryAgency.businessNum = ''; onSubmit();"></button>
        </div>
      </div>

      <div class="request-container">
        <div class="requirements">10. 배달대행회사 연락처 : </div>
        <div class="input-box">
          <input type="text" name="" class="input-item input-item-default" v-model="request.deliveryAgency.contact" :placeholder="``" @keyup="onSubmit" ref="contact">
          <button class="btn-empty" :class="{ on: request.deliveryAgency.contact.length > 0 }" @click="request.deliveryAgency.contact = ''; onSubmit();"></button>
        </div>
      </div>

      <div class="personal-information-policy" :class="{ on: personalInformationPolicy }" @click="checkPolicy">
        <span><button class="link" @click.self="link">개인정보 처리 방침</button>에 동의합니다.</span>
      </div>

      <div class="button-container">
        <button class="btn-submit" @click="doRequest" :disabled="!btnSubmit">신청하기</button>
      </div>
    </div>

    <ResultMSG></ResultMSG>    
  </div>
</template>

<script>
import vuex from 'vuex'
import moment from 'moment'

import ResultMSG from '../components/modals/ResultMessage.vue'

export default {
  components: {
    ResultMSG
  },
  data () {
    return {
      request: {
        id: '',
        pw: '',
        name: '',
        hp: '',
        storePhoneNumber: '',
        email: '',
        deliveryName: '',
        deliveryAccountNumber: '',
        deliveryPhoneNumber: '',
        deliveryAgency: {
          name: '',
          businessNum: '',
          contact: ''
        }
      },
      file: {
        business: '선택한 파일이 없습니다.',
        resident: '선택한 파일이 없습니다.'
      },
      personalInformationPolicy: false,
      btnSubmit: false,
      emailErrorMSG: false
    }
  },
  computed: {

  },
  watch: {
    request: (reqeust) => {
      console.log(reqeust)
    },
    GET_LANGUAGE: function (newLang) {
      // let locale = this.$i18n.locale;
      let locale = newLang;
      if (locale === 'ko') {
        this.request.monetaryUnit = 'KRW'
      } else if (locale === 'jp') {
        this.request.monetaryUnit = 'JPY'
      } else {
        this.request.monetaryUnit = 'USD'
      }
    }
  },
  created () {
    this.onSubmit();
  },
  methods: {
    ...vuex.mapMutations({
      'SET_COMPLETE_MSG': 'request/SET_COMPLETE_MSG',
      'SET_CURRENCY_CODE': 'request/'
    }),
    ...vuex.mapActions({
      'REQUEST_RECEIPT': 'request/REQUEST_RECEIPT',
      'UPLOAD_IMAGE': 'request/UPLOAD_IMAGE'
    }),
    setDate () {
      let years = []
      let year = ''

      for (let y=2000; y<2100; y++) {
        years.push(String(y));
      }
      this.years = years;

      year = moment().format('YYYY');
      this.request.year = year

      let months = [];
      let month = '';
      for (let m=1; m<=12; m++) {
        months.push(m<10 ? `0${m}` : `${m}`);
      }
      this.months = months;

      month = moment().format('MM');
      this.request.month = month

      this.setDay();
      this.request.day = moment().format('DD')
    },
    setDay () {
      let y = this.request.year;
      let m = this.request.month;

      let days = [];
      let day = moment(`${y} ${m}`, 'YYYY MM');
      let lastDay = day.endOf('month').format('DD');

      for (let d=1; d<=lastDay; d++) {
        days.push(d<10 ? `0${d}` : `${d}`)
      }

      this.days = days

      if(this.request.day > lastDay) {
        this.request.day = lastDay;
      }
    },
    async doRequest () {
      this.btnSubmit = false;

      let data = this.request;

      let _formData1 = new FormData();
      let brFile = document.querySelector("#BusinessRegistration").files[0];
      _formData1.append("image", brFile)  
      let res1 = await this.UPLOAD_IMAGE(_formData1)
      data.brImg = res1.data.url;

      // let _formData2 = new FormData();
      // let rcFile = document.querySelector("#RegistrationCard").files[0];
      // _formData2.append("image", rcFile)
      // let res2 = await this.UPLOAD_IMAGE(_formData2)
      // data.rcImg = res2.data.url

      console.log(data)

      let res = await this.REQUEST_RECEIPT(data)
      console.log('doRequest', res)

      this.SET_COMPLETE_MSG(true)

      if (res.status === 200) {
        this.request = {
          ...this.request,
          email: '',
          preCard: '',
          postCard: '',
          amount: '',
          msg: ''
        }
      }

      this.btnSubmit = true;
    },
    onSubmit () {
      let result = this.watchRequestData();

      this.btnSubmit = result
    },
    onSubmitEmail () {
      let { email } = this.request;

      this.$refs.email.blur();
      this.$refs.email.focus();

      this.onSubmit();

      // let regExp = /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;
      let regExp = /^[0-9a-zA-Z-_.]*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\./i;
      if (!regExp.test(email)) {
        this.emailErrorMSG = true;
        return;
      }
      this.emailErrorMSG = false;
    },
    watchRequestData () {
      let id, pw, name, hp, storePhoneNumber, email, deliveryName, deliveryAccountNumber, deliveryPhoneNumber;
      ({id, pw, name, hp, storePhoneNumber, email, deliveryName, deliveryAccountNumber, deliveryPhoneNumber} = this.request)
      let { name: da_name, businessNum, contact } = this.request.deliveryAgency;

      console.log(da_name, businessNum, contact)

      if (id === '') {
        console.log(1, 'ID를 입력해주세요.')
        return false;
      } 

      if (pw === '') {
        console.log(2, 'Password를 입력해주세요.')
        return false;
      }

      if (name === '') {
        console.log(3, '신청자 이름')
        return false;
      }

      if (hp === '') {
        console.log(4, 'HP')
        return false;
      }

      if (storePhoneNumber === '') {
        console.log(5)
        return false;
      }
      
      // let regExp = /^[0-9a-zA-Z][-_.]+@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;
      let regExp = /^[0-9a-zA-Z-_.]*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\./i;
      

      let except = email.replace(/_/g, '').replace(/-/g, '').replace(/./g, '');
      console.log(except)

      if (!regExp.test(email)) {
        console.log(6, '유효하지 않은 E-mail을 입력하셨습니다.')
        return false;
      }
      
      if (deliveryName === '') {
        console.log(7)
        return false;
      }
      
      if (deliveryAccountNumber === '') {
        console.log(8)
        return false;
      }
      
      if (deliveryPhoneNumber === '') {
        console.log(9)
        return false;
      }

      let file1 = document.querySelector("#BusinessRegistration").files[0];
      if (file1 === undefined) {
        this.file.business = '선택한 파일이 없습니다.';
        return false;
      }
      
      // let file2 = document.querySelector("#RegistrationCard").files[0];
      // if (file2 === undefined) {
      //   this.file.resident = '선택한 파일이 없습니다.';
      //   return false; 
      // } 

      if(!this.personalInformationPolicy) {
        return false;
      }

      if(da_name === '') {
        return false
      }

      if(businessNum === '') {
        return false
      }

      if(contact === '') {
        return false
      }

      return true
    },
    businessFile(e) {
      let file = document.querySelector("#BusinessRegistration").files[0];

      if (file === undefined) {
        this.file.business = '선택한 파일이 없습니다.';
        return;
      }
      this.file.business = file.name;

      let result = this.watchRequestData();

      this.btnSubmit = result
    },
    residentFile(e) {
      let file = document.querySelector("#RegistrationCard").files[0];

      if (file === undefined) {
        this.file.resident = '선택한 파일이 없습니다.';
        return;
      }
      this.file.resident = file.name;

      let result = this.watchRequestData();

      this.btnSubmit = result
    },
    businessBtn() {
      console.log(this.$refs.business)
      this.$refs.business.focus();
    },
    checkPolicy() {
      this.personalInformationPolicy = !this.personalInformationPolicy;

      let result = this.watchRequestData();

      this.btnSubmit = result
    },
    link(e) {
      var win = window.open('https://form.elixirpay.co.kr/admin/doc/privacy/30', '_blank');
      win.focus();
      this.personalInformationPolicy = !this.personalInformationPolicy;
    }
  }
}
</script>

<style lang="scss">
#ReceiptRequest {
  max-width: 768px;
  margin: 0 auto;
  padding: 42px 30px 24px;

  .receipt-request-container {
    .title {
      height: 34px;

      font-size: 24px;
      font-weight: bold;
      color: $color_a;

      text-align: center;
      line-height: 1.42;
    }

    .guide {
      height: 48px;
      margin-top: 6px;

      font-size: 15px;

      text-align: center;
      line-height: 1.6;

      word-wrap: break-word; 
      word-break: keep-all;
      // word-break: break-all;
    }

    .request-container {
      margin-top: 42px;

      .requirements {
        overflow: hidden;
        min-height: 24px;

        font-size: 15px;
        
        line-height: 1.6;

        word-wrap: break-word; 
        word-break: keep-all;
        // word-break: break-all;
      }

      .input-box {
        position: relative;

        margin-top: 6px;

        .input-item {
          width: 100%;
          height: 50px;
          padding: 10px;

          border-bottom: solid 1px #e0e0e0;
          font-size: 17px;

          line-height: 1.65;

          transition: all .125s;

          &::-webkit-input-placeholder, &:-ms-input-placeholder, &::placeholder {
            color: $black-30;
          }

          &:focus {
            border-bottom-color: $color_a;
          }
        }

        .input-file {
          position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px; overflow: hidden; clip:rect(0,0,0,0); border: 0;
        }

        .btn-empty {
          display: none;
          position: absolute;
          right: 0;
          width: 40px;
          height: 50px;

          background-image: url('../images/del-nor.svg');
          background-size: 40px;
          background-position: center;
          background-repeat: no-repeat;
          
          &:active {
            background-image: url('../images/del-act.svg')
          }

        }

        .btn-empty.on {
          display: inline;
        }

        select {
          background-image: url('../images/dropdown.svg');
          background-size: 40px;
          background-position: right center;
          background-repeat: no-repeat;
        }

        .input-item-default, .amount {
          padding-right: 30px !important;
        }

        .file-select-box {
          display: flex;
          width: 100%;

          .file-select-inputbox {
            flex: 1;
            
            display: flex;
            align-items: center;
            padding: 10px;

            border-bottom: 1px solid #e0e0e0;
            font-size: 17px;
            color: rgba($color: #000000, $alpha: .3)
          }

          .file-select-button {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-basis: 120px;
            width: 120px;
            height: 50px;
            margin-left: 6px;

            border: 1px solid $color_a;
            border-radius: 25px;
            font-size: 17px;
            color: $color_a;
          }          
        }
      }

      .input-box-card {
        display: flex;

        .input-item-card {
          max-width: 225px;
        }

        .card-number-middle {
          min-width: 108px;
          padding: 0 6px;

          text-align: center;
          line-height: 50px;
        }
      }

      .input-box-amount {
        display: flex;

        .amount-unit {
          min-width: 100px;
          max-width: 250px;;
          height: 50px;
          margin-right: 6px;
          padding: 12px;

          border-bottom: solid 1px #e0e0e0;
          font-size: 17px;
          font-weight: bold;

          // color: #b3b3b3;
        }

        .amount-selected {
          color: #424242;
        }

        .amount {
          flex-grow: 1;

          height: 50px;
          padding: 10px;

          border-bottom: solid 1px #e0e0e0;
          font-size: 17px;
        }
      }

      .input-box-date {
        display: flex;
        flex-direction: column;

        .date-box {
          display: flex;
          width: 100%;
          height: 50px;
          margin-top: 6px;

          .date-selector {
            flex-grow: 1;
            padding: 12px;

            font-size: 17px;
            font-weight: bold;
            color: #b3b3b3;

            border-bottom: solid 1px #b3b3b3;
          }

          .date-selector.on {
            color: #424242;
          }

          .date-unit {
            flex-grow: 60px;
            width: 60px;
            height: 50px;
            padding-left: 6px;

            font-size: 15px;
            color: #424242;

            line-height: 50px;
          }
        }

        @media all and (min-width: 768px) {
          flex-direction: row;
        }
      }

      .input-row-box {
        position: relative;
        display: flex;
        align-items: center;
        height: 50px;
        margin-top: 6px;

        .row-title {
          flex-basis: 104px;
          padding-left: 10px;
          padding-right: 6px;

          font-size: 15px;
          color: #424242;

          line-height: 1.6;
        }
        .row-input {
          flex: 1;
          height: 100%;
          padding: 10px;

          border-bottom: 1px solid #e0e0e0;
          font-size: 17px;
          transition: all .125s;

          &::-webkit-input-placeholder, &:-ms-input-placeholder, &::placeholder {
            color: $black-30;
          }

          &:focus {
            border-bottom-color: $color_a;
          }
        }
        .btn-empty {
          display: none;
          position: absolute;
          right: 0;
          width: 40px;
          height: 50px;

          background-image: url('../images/del-nor.svg');
          background-size: 40px;
          background-position: center;
          background-repeat: no-repeat;
          
          &:active {
            background-image: url('../images/del-act.svg')
          }

        }

        .btn-empty.on {
          display: inline;
        }
      }

      .email-error-msg {
        overflow: hidden;
        height: 0px;
        padding-left: 10px;
        font-size: 12px;
        color: red;

        line-height: 0px;

        transition: all .1s;

        &.show {
          height: 30px;
          line-height: 30px;
        }
      }

    }

    .personal-information-policy {
      display: flex;
      align-items: center;
      width: 100%;
      height: 58px;
      margin-top: 42px;
      padding-left: 45px;

      font-size: 15px;

      background-image: url('../images/check-none.svg');
      background-position: left center;
      background-repeat: no-repeat;

      &:active {
        background-image: url('../images/check-pre.svg');
      }

      &.on {
        background-image: url('../images/check-act.svg');
      }

      span {
        strong {
          text-decoration: underline;
        }
      }

      .link {
        font-size: 15px;
        text-decoration: underline;
      }
    }

    .button-container {
      text-align: center;

      .btn-submit {
        width: 100%;
        max-width: 600px;
        height: 60px;
        margin-top: 42px;

        border-radius: 100px;
        font-size: 20px;

        background-color: $color_a;
        color: #fff;

        transition: all .5s;

        &:disabled {
          background-color: #e0e0e0;
        }
        &:active {
          background-color: $color_a_d;
        }
      }
    }
  }  
}
</style>